"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = wrap;
var _partial = _interopRequireDefault(require("./partial.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Returns the first function passed as an argument to the second,
// allowing you to adjust arguments, run code before and after, and
// conditionally execute the original function.
function wrap(func, wrapper) {
  return (0, _partial.default)(wrapper, func);
}